var checkForChangedInput = {

	/**
	 * Initializes the checkForChangedInput functions.
	 *
	 * @param {object}
	 *
	 * @returns {void}
	 */
	init: function(target) {
		checkForChangedInput.initFields(target);
		checkForChangedInput.initEvents(target);
	},

	/**
	 * Initializes field attributes.
	 *
	 * @param {HTMLElement} target - The target DOM element to process field attributes on.
	 *
	 * @returns {void}
	 */
	initFields: function(target) {
		const fields = target.querySelectorAll('[data-check-for-changed-input]');
		fields.forEach(checkForChangedInput.procesFieldAttributes);
	},

	/**
	 * Processes field attributes.
	 *
	 * @param {HTMLElement} element - The DOM element representing the input field.
	 *
	 * @returns {void}
	 */
	procesFieldAttributes: function(element) {
		let nameOriginal = element.getAttribute('name');
		element.setAttribute('data-name-original', nameOriginal);
		element.removeAttribute('name');

		let valueOriginal = element.getAttribute('value') || element.getAttribute('data-value') || '';
		element.setAttribute('data-value-original', valueOriginal);
	},

	/**
	 * Initializes event listeners for input fields.
	 *
	 * @param {HTMLElement} target - The target DOM element to attach event listeners to.
	 *
	 * @returns {void}
	 */
	initEvents: function(target) {

		let elements = target.querySelectorAll('[data-check-for-changed-input]');
		elements.forEach(function(element) {
			element.addEventListener('blur', checkForChangedInput.checkForChange);
		});

	},

	/**
	 * Handles change detection for an input field.
	 *
	 * @param {Event} event - The blur event triggered by the input field.
	 *
	 * @returns {void}
	 */
	checkForChange: function(event) {
		const field = event.target;
		const originalName = field.getAttribute('data-name-original');
		const originalValue = field.getAttribute('data-value-original');

		if (field.value != originalValue) {
			field.setAttribute('name', originalName);
		} else {
			let revertName = field.getAttribute('name');
			if (null !== revertName && 'undefined' !== typeof revertName) {
				field.setAttribute('data-name-original', field.getAttribute('name'));
				field.removeAttribute('name');
			}
		}
	}

};
export default checkForChangedInput;
